import { baseApi } from '@api/baseApi';
import { UserData } from '@api/user/types/UserData';
import { FullFilter } from '@api/user/types/FullFilter';



const userApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		
		// get user data
		getUserData: builder.query<UserData, void>({
			query: () => ({
				url: 'User/GetUserData',
			}),
			providesTags: ['userData']
		}),

		resetUserData: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['userData'],
		}),


		// get full filter
		getFullFilter: builder.query<FullFilter, void>({
			query: () => ({
				url: 'User/GetFullFilter',
			}),
			providesTags: ['fullFilter']
		}),

		resetFullFilter: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['fullFilter'],
		}),


		// save filter
		saveUserData: builder.mutation<boolean,Pick<UserData, 'filter'>>({
			query: (userData) => ({
				url: 'User/SaveUserData',
				method: 'POST',
				body: userData
			}),
			async onQueryStarted(_, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled;
				} finally {
					dispatch(baseApi.util.resetApiState())
				}
			},
			invalidatesTags: ['userData'],
		}),
	}),
});


export const {
	useLazyGetUserDataQuery,
	useResetUserDataMutation,
	useGetFullFilterQuery,
	useResetFullFilterMutation,
	useSaveUserDataMutation } = userApi;